/**
 * Dev-only logging helper.
 *
 * `console.debug` calls scattered across the codebase are useful during
 * development but the code-quality reports flag them for production builds.
 * Wrap them behind `NODE_ENV !== "production"` so they get stripped by the
 * webpack/CRA bundler dead-code elimination step in production.
 */
export function devDebug(...args) {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.debug(...args);
  }
}
